import React, { useRef, useEffect, useState } from 'react';
import HelpTooltipWrapper from './HelpTooltip.styles'

export default function HelpTooltip(props) {
  const [focus, setFocus] = useState(false);
  const {
    activateClassName,
    children,
    fixed,
    hideIcon,
    inline,
    messageStyles,
    onClose,
    show,
  } = props;
  const wrapperRef = useRef();

  const closeTooltip = () => {
    setFocus(false);
    if (onClose) onClose();
  };

  const useOutsideClick = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (!fixed) return null;

        if (ref.current && !ref.current.contains(event.target)) {
          return closeTooltip(event, true);
        } return null;
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };

  const useOnMouseOut = (ref) => {
    useEffect(() => {
      function handleOnMouseOut(event) {
        if (fixed) return null;

        const { relatedTarget } = event;
        const { target } = event;
        const classes = ['card-body', 'card help-info', 'help-icon'];

        const relatedTargetClosest = relatedTarget && relatedTarget.closest(classes.map((x) => `.${x}`).join(', '));
        const targetClosest = target && target.closest(classes.map((x) => `.${x}`).join(', '));
        const isActivate = relatedTarget && relatedTarget.classList.contains(activateClassName);

        if (!relatedTarget) return closeTooltip();
        if (isActivate) {
          return (targetClosest || classes.includes(target.className)) ? closeTooltip() : null;
        }
        return (!(classes.includes(relatedTarget.className) || relatedTargetClosest)) ? closeTooltip() : null;
      }
      document.addEventListener('mouseout', handleOnMouseOut);
      return () => {
        document.removeEventListener('mouseout', handleOnMouseOut);
      };
    }, [ref]);
  };

  useOutsideClick(wrapperRef);
  useOnMouseOut(wrapperRef);

  return (
    <HelpTooltipWrapper inline={inline} fixed={fixed} messageStyles={messageStyles}>
      <div className="details-tooltip">
        {!hideIcon
        && (
          <div className="help-icon" onMouseOver={() => setFocus(true)}>
            <i className="fa fa-info-circle" />
          </div>
        )}

        {(focus || show)
        && (
          <div className="card help-info" ref={wrapperRef}>
            <div className="card-body">
              {children}
            </div>
          </div>
        )}
      </div>
    </HelpTooltipWrapper>
  );
}
